(() => {
  if (window.readOrigin04) return;
  window.readOrigin04 = true;
  function attach() {
    const template = document.querySelector('template[data-read-origin-04]');
    if (!template) return;
    document.querySelectorAll('#MainContent strong, #MainContent b').forEach(label => {
      if (!/^(origin|made in|country of origin)$/i.test(label.textContent.trim()) || label.dataset.readOrigin04) return;
      label.dataset.readOrigin04 = '1';
      let last = label;
      while (last.nextSibling && last.nextSibling.nodeName !== 'BR' && last.nextSibling.nodeName !== 'STRONG') last = last.nextSibling;
      last.after(template.content.cloneNode(true));
    });
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; attach(); });
  });
  observer.observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true});
  attach();
  document.addEventListener('shopify:section:load', attach);
})();
